import api from './api';

export const listNotificationEventCatalog = () =>
    api.get('/admin/camera-notification-events')
       .then(r => r.data);

export const listRecipientCandidates = ({ search, limit = 100 } = {}) =>
    api.get('/admin/camera-notification-recipient-candidates', { params: { search, limit } })
       .then(r => r.data);

export const listCameraNotificationGroups = (cameraId) =>
    api.get(`/admin/cameras/${cameraId}/notification-groups`)
       .then(r => r.data);

export const createNotificationGroup = (cameraId, body) =>
    api.post(`/admin/cameras/${cameraId}/notification-groups`, body)
       .then(r => r.data);

export const updateNotificationGroup = (cameraId, groupId, body) =>
    api.put(`/admin/cameras/${cameraId}/notification-groups/${groupId}`, body)
       .then(r => r.data);

export const deleteNotificationGroup = (cameraId, groupId, version) =>
    api.delete(`/admin/cameras/${cameraId}/notification-groups/${groupId}`, { data: { version } })
       .then(r => r.data);

/**
 * Колокольчик уведомлений (Bell Addendum v1.1, раздел 8).
 *
 * Контракт бэкенда frozen. Если эндпоинт ещё не поднят (404/501),
 * колокольчик не рендерится — счётчик из /violations/events не собирается:
 * это была бы вторая, расходящаяся с backend правда о непрочитанном.
 *
 * mark-seen тела запроса не требует: backend сам отмечает «прочитано до»
 * последнего подтверждённого события и возвращает
 * { status, seen_through_event_id, seen_through_confirmed_at }.
 */

export const getNotificationsSummary = () =>
  api.get('/notifications/summary').then((response) => response.data);

export const markNotificationsSeen = () =>
  api.post('/notifications/mark-seen').then((response) => response.data);
